import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { IDisbursementOccurrence } from 'src/app/interfaces/disbursement-occurrence';
import { IDisbursementSession } from 'src/app/interfaces/disbursement-session';
import { IFundingAccount } from 'src/app/interfaces/funding-account';
import { IPaymentResponse } from 'src/app/interfaces/payment-response';
import { IFundingAccountsResponse } from 'src/app/interfaces/funding-accounts-response';
import { FundingAccountsService } from 'src/app/services/funding-accounts.service';
import { PaymentsService } from 'src/app/services/payments.service';
import { DisbursementOccurrenceService }  from "../../services/disbursement-occurrence.service";
import { SharedService } from 'src/app/services/shared.service';
//import { ITestDisbursementOccurrence } from 'src/app/interfaces/disbursement-occurrence';

// const DUMMY_FUNDING_ACCOUNT : IFundingAccount = {
//   tokenid: "0",
//   fundingSubtype: "dummy",
//   singleUse: "true",
//   institutionName: "dummy",
//   signatureDebit: false,
//   fundingAccountNickname: "<Select Funding Method>"
// }

@Component({
  selector: 'app-disbursement-occurrence',
  templateUrl: './disbursement-occurrence.component.html',
  styleUrls: ['./disbursement-occurrence.component.css']
})
export class DisbursementOccurrenceComponent implements OnInit {

  @Input() dsbOccurrence!: IDisbursementOccurrence;

  @Input() fundingAccounts: IFundingAccount[] = [];

  @ViewChild('fundingAccountsDropdown') fundingAccountsDropdown!: ElementRef;

  selectedFundingAccountToken = '0';

  dsbMessage!: string;
  isDsbMessageShown: boolean = false;

  envRegion!: string;
  disbursementSession!: IDisbursementSession;  

  //selectedFundingAccount?: IFundingAccount = DUMMY_FUNDING_ACCOUNT;

	// onSelected(value: any): void {
  //   debugger;
  //   console.log(value);
	// 	this.selectedFundingAccountToken = this.fundingAccountsDropdown.nativeElement.value;
  //   console.log('this.selectedFundingAccountToken' + this.selectedFundingAccountToken);
	// }

  // private lookupFundingAccountByToken(token: string): IFundingAccount {
  //   this.fundingAccounts.forEach(fa => {
  //     if(token == fa.tokenid) {
  //       return fa;
  //     }
  //     return DUMMY_FUNDING_ACCOUNT;
  //   })
  // }

	onSelected() {
		// this.selectedFundingAccountToken = this.fundingAccountsDropdown.nativeElement.value;
    // this.dsbOccurrence.fundingAccountToken = this.selectedFundingAccountToken;
		this.selectedFundingAccountToken = this.dsbOccurrence.fundingAccountToken || '0';

    // console.log('this.selectedFundingAccountToken' + this.selectedFundingAccountToken);
    // console.log('', this.dsbOccurrence.fundingAccountToken);
	}


  public constructor(
      private router: Router,
      private fundingAccountsService: FundingAccountsService,
      private paymentsService: PaymentsService,
      private dsbOccurrenceService: DisbursementOccurrenceService,
      private sharedService: SharedService
  ) {}

  ngOnInit(): void {
    //this.getFundingAccounts();
    this.envRegion = this.sharedService.getEnvRegion();
    this.disbursementSession = this.sharedService.getDisbursementSession();
  }

  // get selectedFundingAccountDescription(): string  {
  //   // Lookup for the funding account in the list of funding accounts by
  //   // the token stored in the current occurrence
  //   let selectedFundingAccount: IFundingAccount | null = null;
  //   let paymentFaToken = this.dsbOccurrence.payments[0]?.fundingAccountToken;
  //   this.fundingAccounts.forEach((fa) => {
  //     if(paymentFaToken == fa.tokenid) {
  //       selectedFundingAccount = fa;
  //       return;
  //     }
  //   })
  //   return (selectedFundingAccount != null) ? selectedFundingAccount["fundingAccountNickname"] : '';
  // }

  get selectedFundingAccountDescription(): string  {
    if(this.dsbOccurrence.payments && this.dsbOccurrence.payments.length > 0 && this.dsbOccurrence.payments[0]) {
      let s = this.dsbOccurrence.payments[0].accountNickname;
      if(!s) {
        s = this.dsbOccurrence.payments[0].maskedFundingAccount;
      }
      return s || 'Unknown';
    } else {
      return 'Unknown (no payments recorded)';
    }
  }


  // getFundingAccounts() {
  //   let disbursementSession = this.sharedService.getDisbursementSession();
  //   let envRegion = this.sharedService.getEnvRegion();
  //   if (disbursementSession && envRegion) {
  //     this.fundingAccountsService.fetchFundingAccounts(envRegion, disbursementSession.sessionId)
  //     .subscribe(
  //       (response) => {
  //         let fundingAccountResponse = response;
  //         if (fundingAccountResponse) {
  //           this.fundingAccounts = fundingAccountResponse.tokenList;
  //           //this.fundingAccounts.push(DUMMY_FUNDING_ACCOUNT);
  //           this.fundingAccounts.sort((a, b) => (a.tokenid > b.tokenid) ? 1 : -1);
  //           ///// this.fundingAccounts.slice(0, 3);
  //           // Add a column for the checkbox
  //           this.fundingAccounts.map((obj) => {
  //             obj.checked = false;
  //             return obj;
  //           })

  //           // **** test ***
  //           //this.selectedFundingAccount = this.fundingAccounts[2];



  //           // // Figure out the message for the customer depending on whether there is already at least one funding account
  //           // if (this.fundingAccounts) {
  //           //   if (this.fundingAccounts.length > 0) {
  //           //     this.dsbMessage = this.sharedService.getCustomizedPrompt("FUNDING_ACCOUNTS_EXIST");
  //           //   }
  //           // }
  //         }
  //       }
  //     )
  //   }
  // }


  // private dec2unicode(n: number) : string {
  //   return '\\' + 'u' + n.toString(16);
  // }

  get statusSymbol() {
    switch(this.dsbOccurrence.status) {
      case 'CREATED':
        return String.fromCharCode(9757);
      case 'SUBMITTED':
        return String.fromCharCode(9989);   //10071);
      case 'FUNDING_SELECTED':
        return String.fromCharCode(10022);
      case 'PENDING':
        return String.fromCharCode(11093);
      case 'COMPLETED':
        return String.fromCharCode(9989);
      case 'ERROR':
        return String.fromCharCode(10071);   
      case 'FAILED':
        return '🔥';
    }
    // return '🔥 🔥\u203C \u274C \u26A0 \u2705 \u26A1 \u2B55 \u2726 \u2757 \u2130';
    return '';

  }

  get statusDescription() {
    switch(this.dsbOccurrence.status) {
      case 'CREATED':
      case 'INVITED':
      case 'VIEWED':
        return 'FUNDS AVAILABLE';
      case 'CANCELLED':
          return 'CANCELLED';
      case 'SUBMITTED':
        return 'SUBMITTED';
      case 'PENDING':
        return 'PENDING';
      case 'COMPLETED':
        return 'COMPLETED';
      case 'FAILED':
        return 'WE HAVE PROBLEM... ';
      case 'ERROR':
        return 'ERROR ';
      case 'EXPIRED':
        return 'EXPIRED ';
        }
    return '';
  }

  // get statusDescription() {
  //   switch(this.dsbOccurrence.status) {
  //     case 'CRE':
  //       return String.fromCharCode(9757) + '  FUNDS ARE AVAILABLE'; // 9889  128512);
  //     case 'SUB':
  //       return String.fromCharCode(10071) + '  SUBMITTED';
  //     case 'PROCESSED':
  //       return String.fromCharCode(9989) + '  PROCESSED';
  //     case 'FAILED':
  //       return '🔥  WE HAVE PROBLEM... ';

  //   }
  //   return 'HMM... 🔥 🔥\u203C \u274C \u26A0 \u2705 \u26A1 \u2B55 \u2726 \u2757 \u2130';        // + String.fromCharCode(10067);
  // }

  onChooseFundingAccount(dsbOccurrenceUuid: string) {
    console.log('onChooseFundingAccount', dsbOccurrenceUuid);
    let navigationExtras: NavigationExtras = {
        state: {
          dsbOccurrenceUuid: dsbOccurrenceUuid
        },
      };
      console.log('onChooseFundingAccount', navigationExtras);
    this.router.navigate(['/dsb-funding-accounts'], navigationExtras);
  }

  onDisburseFunds() {
    // console.log('onDisburseFunds: ' + this.fundingAccountsDropdown.nativeElement.value);
    this.dsbMessage = '';
    this.isDsbMessageShown = false;
    this.paymentsService.disburseFunds(this.selectedFundingAccountToken, this.dsbOccurrence.disbursementOccurrenceUuid)
    .subscribe({
      next: (response) => {
        if (response) {
          if (response.messageCode == "0") {
            this.dsbMessage = `Successfully processed disbursement of funds. Confirmation #: ${response.confirmationNumber}`;
            this.dsbOccurrence.status = 'SUBMITTED';
            this.dsbOccurrence.disbursable = false;
          }
          else {
            this.dsbMessage = `${response.messageText}`;
            this.selectedFundingAccountToken = '0';
          }
        } else {
          this.dsbMessage = `System errorr occurred.`;
          this.selectedFundingAccountToken = '0';
        }
        this.isDsbMessageShown = true;
      },
      error: (e) => {
          this.dsbMessage = e;
          this.isDsbMessageShown = true;
          this.selectedFundingAccountToken = '0';
        },
      complete: () => {
        this.refreshDsbOccurrence();
      }
    });

  }

  refreshDsbOccurrence () {
    this.dsbOccurrenceService.fetchDisbursementOccurrence(
      this.envRegion, this.disbursementSession.sessionId, this.dsbOccurrence.disbursementOccurrenceId)
    .subscribe({
      next: (response) => {
        if (response) {
          this.dsbOccurrence = response;
          // this.dsbOccurrence.status = response.status;
          this.dsbOccurrence.disbursable = true;
          if (this.dsbOccurrence.status == 'SUBMITTED' || this.dsbOccurrence.status == 'FAILED') {
            this.dsbOccurrence.disbursable = false; 
          } else {
            this.dsbOccurrence.fundingAccountToken = '0';
          }
        }
      },
      error: (error) => {
      },
      complete: () => {
      }
    })


 }
  // from Ark Furmansky (internal) (internal) to Everyone:    5:36  PM
  // public getDisbursementReasons(): any[] {
  //   let dsbReasons: any[] = [];
  //   let brandProfile = this.getBrandProfile();
  //   let configProperties = brandProfile.configProperties;
  //   for (const propName in configProperties) {
  //     if (propName == 'DSB_PAYMENT_REASONS') {
  //       dsbReasons = JSON.parse(configProperties[propName]);
  //     }
  //   }
  //   return dsbReasons;
  // }

  // paymentReasons!: any[];
  // from Ark Furmansky (internal) (internal) to Everyone:    5:44  PM
  //     .subscribe({
  //       next: (response) => {
  //       },
  //       error: (error) => {
  //       },
  //       complete: () => {
  //       }
  //     });
}
